import { render, staticRenderFns } from "./Spark.vue?vue&type=template&id=bcef2c80&"
import script from "./Spark.vue?vue&type=script&lang=js&"
export * from "./Spark.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bcef2c80')) {
      api.createRecord('bcef2c80', component.options)
    } else {
      api.reload('bcef2c80', component.options)
    }
    module.hot.accept("./Spark.vue?vue&type=template&id=bcef2c80&", function () {
      api.rerender('bcef2c80', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/icons/products/Spark.vue"
export default component.exports